import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
// import { getOpenId, getToken, removeToken } from '@/utils/auth';
// import { WEBSITE_TITLE } from '@/config';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '金陵科技学院-艺术学院',
    },
  },
  {
    path: '/content',
    name: 'Content',
    component: () => import('@/views/Content.vue'),
    meta: {
      title: '金陵科技学院-艺术学院',
    },
  },
  {
    path: '/list',
    name: 'List',
    component: () => import('@/views/List.vue'),
    meta: {
      title: '金陵科技学院-艺术学院',
    },
  },
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  next();
});
export default router;
